import { useRequestCompileContext } from 'client/components/schema/requests/compile-context/RequestCompileContext';
import {
  ContextualValue,
  formatContextualValue
} from 'common/schema/contextual-value/ContextualValue';
import { isContextualValueEditable } from 'common/schema/contextual-value/isContextualValueEditable';
import { isContextualValueEmpty } from 'common/schema/contextual-value/isContextualValueEmpty';
import { IMetadata } from 'common/schema/metadata/Metadata';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { IRequest } from 'common/schema/request/Request';
import { IWidget } from 'common/schema/widget/Widget';
import { WidgetLogic } from 'common/schema/widget/WidgetLogic';

export function contextualFormWidgetProps(
  request: IRequest,
  widget: IWidget,
  metadata: IMetadata
) {
  if (!metadata.contextual) return undefined;
  if (request.citizen == null) return undefined;

  const context = ContextualValue.find(metadata.contextual);
  const value = context.fromRequest(request) as any;

  // Se il metadato è modificabile anche se contestuale, ne permettiamo
  // la modifica.
  if (isContextualValueEditable(metadata)) {
    return {
      defaultValue: value,
      placeholder: formatContextualValue(value)
    };
  }

  // Ne permettiamo la modifica anche se il campo è vuoto
  // il metadato lo permette
  if (isContextualValueEmpty(value) && !context.disableIfEmpty) {
    return {
      defaultValue: value
    };
  }

  // In questo caso, il cittadino è autenticato, quindi forziamo i valori dal
  // contesto (`request.citizen`)
  return {
    disabled: true,
    value,
    onChange: () => {}
  };
}
